import apiClient from '../utils/apiClient';
import { PortalUserSessionsDTO, PortalUserSessionFailedLoginAttemptCountDto, PortalUsersSessionLisRequest } from '../types/PortalUser';
 
export const getPortalUserSessionList = async (portalUsersSessionLisRequest? :PortalUsersSessionLisRequest): Promise<PortalUserSessionsDTO[]> => {
   const response = await apiClient.post<PortalUserSessionsDTO[]>(`/Portal/user-session-list`,portalUsersSessionLisRequest);
   return response.data;
 };

 export const updatePortalUserSessionFailedLoginAttemptCount = async (portalUserSessionFailedLoginAttemptCount :PortalUserSessionFailedLoginAttemptCountDto): Promise<string> => {
  const response = await apiClient.put<string>(`/Portal/user-session-failed-login-attempt`,{...portalUserSessionFailedLoginAttemptCount});
  return response.data;
};

 